module.exports = __webpack_public_path__ + "img/chanpin4.82df85fb.png";